export class PaymentMethods {
	static readonly TARJETA = 'Tarjeta';
	static readonly TRANSFERENCIA = 'Transferencia';
	static readonly BILLETERA = 'Billetera';
	static readonly YAPE = 'Yape';
}